import {AfterContentInit, Component, ContentChildren, Input, QueryList, TemplateRef, ViewChild} from '@angular/core';
import {RcTableCellComponent} from './rc-table-cell.component';

@Component({
    selector: 'lib-rc-table-row',
    template: `<ng-template #tableRow>
  <div class="rc-table-row">
    <ng-container *ngFor="let cell of cells.toArray(); let i = index">
        <ng-container [ngTemplateOutlet]="cell.tableCell" [ngTemplateOutletContext]="{col: cols[i]}"></ng-container>
    </ng-container>
  </div>
</ng-template>`,
    styles: [``]
})
export class RcTableRowComponent implements AfterContentInit{
    @Input() cols: any[] = [];
    @Input() rowData: any[] = [];
    @Input() rowDisabled = false;
    @Input() drawerDisabled = false;
    @ContentChildren(RcTableCellComponent) cells: QueryList<RcTableCellComponent>;
    @ViewChild('tableRow', {read: TemplateRef}) tableRow;

    public show;

    ngAfterContentInit() {
    }

}
